import React, { useState, useEffect, useRef } from 'react';
import './SplashScreen.css';

const LOGO_SPLASH = `${process.env.PUBLIC_URL || ''}/images/logo.png`;
const LOGO_FALLBACK = `${process.env.PUBLIC_URL || ''}/images/logo_liturgia_transparente.png`;

const SplashScreen = ({ onFinish }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [logoSrc, setLogoSrc] = useState(LOGO_SPLASH);
  const hasFinishedRef = useRef(false);
  const animationTimeoutRef = useRef(null);
  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    const startTime = Date.now();
    const minDisplayTime = 2000; // Mínimo 2 segundos para mostrar la presentación
    const maxDisplayTime = 3500; // Máximo 3.5 segundos

    const hideSplash = () => {
      if (hasFinishedRef.current) return;
      
      setIsAnimating(true);
      hideTimeoutRef.current = setTimeout(() => {
        setIsVisible(false);
        if (!hasFinishedRef.current && onFinish) {
          hasFinishedRef.current = true;
          onFinish();
        }
      }, 500); // 0.5s para la animación de salida
    };

    const checkAndHide = () => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, minDisplayTime - elapsed);
      
      setTimeout(hideSplash, remaining);
    };

    // Si la página ya está cargada, mostrar la presentación por el tiempo mínimo
    if (document.readyState === 'complete') {
      checkAndHide();
    } else {
      // Esperar a que la página cargue, pero con timeout máximo
      const handleLoad = () => {
        checkAndHide();
      };
      
      window.addEventListener('load', handleLoad, { once: true });
      
      // Timeout de seguridad: máximo 3.5 segundos
      animationTimeoutRef.current = setTimeout(hideSplash, maxDisplayTime);
    }

    return () => {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
      if (hideTimeoutRef.current) {
        clearTimeout(hideTimeoutRef.current);
      }
      window.removeEventListener('load', checkAndHide);
    };
  }, [onFinish]);

  // No renderizar si ya no es visible
  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${isAnimating ? 'fade-out' : 'fade-in'}`}>
      <div className="splash-content">
        <div className="splash-logo">
          <div className="splash-escudo-wrapper">
            <img
              src={logoSrc}
              alt="Logo Diócesis de Ipiales"
              className="splash-logo-image"
              onError={() => setLogoSrc(LOGO_FALLBACK)}
            />
          </div>
        </div>
      </div>
      {/* Loader de puntos fuera del content para posición fija */}
      <div className="splash-loader">
        <div className="loader-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;

